import script from "./SystemEmailDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemEmailDisplay.vue?vue&type=script&setup=true&lang=js"

import "./SystemEmailDisplay.vue?vue&type=style&index=0&id=2e771672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e771672"]])

export default __exports__